import {CSSProperties, FC} from 'react';


export interface IIconParkingBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconParkingBmw: FC<IIconParkingBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12.005 5c-4.136 0-7.5 3.364-7.5 7.5s3.365 7.5 7.5 7.5 7.5-3.364 7.5-7.5S16.14 5 12.005 5Zm.412 8.333h-1.25v2.084a.416.416 0 1 1-.834 0V9.583c0-.23.187-.416.417-.416h1.667c1.148 0 2.083.934 2.083 2.083 0 1.15-.935 2.083-2.083 2.083Zm-6.59-6.435a8.308 8.308 0 0 0-2.16 5.602c0 2.009.72 4.018 2.16 5.602a.413.413 0 0 1-.006.574l-.59.59a.421.421 0 0 1-.605-.007A9.968 9.968 0 0 1 2 12.5c0-2.426.875-4.853 2.626-6.759a.421.421 0 0 1 .604-.007l.591.59a.413.413 0 0 1 .006.574ZM18.77 5.734a.421.421 0 0 1 .604.007A9.968 9.968 0 0 1 22 12.499a9.968 9.968 0 0 1-2.626 6.76.421.421 0 0 1-.604.007l-.591-.59a.413.413 0 0 1-.006-.574 8.307 8.307 0 0 0 2.16-5.602c0-2.009-.72-4.018-2.16-5.602a.413.413 0 0 1 .006-.574l.59-.59ZM11.166 10h1.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25h-1.25V10Z" clipRule="evenodd" />
        </svg>
    );
};
